"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const Text_1 = __importDefault(require("../Text"));
/** A compact, looped animation giving the user feedback that a process is currently running. */
const LoadingIndicator = (_a) => {
    var { label, size = 'normal' } = _a, props = __rest(_a, ["label", "size"]);
    const normal = 16;
    const sizes = {
        normal,
        big: 2 * normal,
        large: 3 * normal,
    };
    const testId = props['data-testid'] || 'loading-indicator';
    return (react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center", "data-testid": testId },
        react_1.default.createElement(CircularProgress_1.default, { size: sizes[size] || size }),
        label && (react_1.default.createElement(Box_1.default, { ml: 1 },
            react_1.default.createElement(Text_1.default, null, label)))));
};
exports.default = LoadingIndicator;
//# sourceMappingURL=index.js.map